import { useState, useEffect } from 'react';
import { DEVICES, debounce } from 'common-utilities';

function useDeviceType(width) {
	const maxMobileWidth = typeof width === 'number' && width > 0 ? width : 820;
	const [device, setDevice] = useState('');
	useEffect(() => {
		let currentWidth = document.body.clientWidth;
		setDevice(currentWidth > maxMobileWidth ? DEVICES.DESKTOP : DEVICES.MOBILE);
		window.addEventListener(
			'resize',
			debounce(() => {
				currentWidth = document.body.clientWidth;
				if (currentWidth > maxMobileWidth) {
					setDevice(DEVICES.DESKTOP);
				} else {
					setDevice(DEVICES.MOBILE);
				}
			}, 500)
		);
		return function cleanup() {
			window.removeEventListener('resize', this);
		};
	}, []);
	return device;
}

export default useDeviceType;
